import React from 'react'
import { graphql } from 'gatsby'
import posed from 'react-pose'
import { TransitionState } from 'gatsby-plugin-transition-link'
import styled from 'styled-components'
import Page from '../components/page'
import H2 from '../components/h2'
import Post from '../components/post'
import Footer from '../components/footer'
import PageHeader from '../components/pageHeader'
import IntroSection from '../components/introSection'
import P from '../components/p'
import Button from '../components/button'

const PageTransitionStates = posed.div({
  startState: {
    opacity: 1,
    y: 0,
  },
  exitedState: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 300,
      ease: 'easeIn',
    },
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 300,
    },
  },
})

const OverlayTransitionStates = {
  startState: {
    opacity: 1,
    transition: {
      duration: 300,
    },
  },
  exitedState: {
    opacity: 1,
    delay: 300,
    applyAtStart: { display: 'block' },
    transition: {
      duration: 300,
    },
  },
  visible: {
    opacity: 0,
    applyAtEnd: { display: 'none' },
    transition: {
      duration: 300,
    },
  },
}

const TransitionOverlay = styled(posed.div(OverlayTransitionStates))`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: #f6f6f6;
  opacity: 1;
`

const WritingPadding = styled.div`
  padding: 0 1.55rem 5rem;
`

const ContentPage = styled.div`
  margin: 10.55rem 0 0;
  padding: 1.45rem 0 0;
`

const Posts = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`

function getTransitionStates(status) {
  if (['entering', 'entered'].includes(status)) {
    return 'visible'
  } else if (['exiting'].includes(status)) {
    return 'exitedState'
  } else if (['exited'].includes(status)) {
    return 'startState'
  }
}

const PageThree = props => (
  <ContentPage>
    <Page>
      <TransitionState>
        {({ transitionStatus: status }) => {
          return (
            <PageTransitionStates pose={getTransitionStates(status)}>
              <PageHeader>
                <H2>Interface Notes</H2>
                <div>
                  <Button
                    onPressed={() => {
                      window.open('https://www.twitter.com/@oscrse')
                    }}
                    showArrow={true}
                  >
                    Get updates on my Twitter
                  </Button>
                </div>
              </PageHeader>
              <WritingPadding>
                <IntroSection>
                  <P>Notes and thoughts about design of internet products.</P>
                  <P>
                    Curated and written by Oscar Nilsson, a product and systems
                    designer working on Minecraft in Stockholm, Sweden. Read
                    more about him <a href="/">here</a>.
                  </P>
                </IntroSection>
              </WritingPadding>
              <Posts>
                {props.data.allMarkdownRemark.edges.map(({ node }) => {
                  return <Post key={node.id} node={node} />
                })}
              </Posts>
              <TransitionOverlay pose={getTransitionStates(status)} />
            </PageTransitionStates>
          )
        }}
      </TransitionState>
    </Page>
    <Footer />
  </ContentPage>
)

export default PageThree

export const pageQuery = graphql`
  query {
    allMarkdownRemark {
      edges {
        node {
          id
          excerpt(pruneLength: 160)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            path
          }
        }
      }
    }
  }
`
